import EVENTS from "../lib/events.js"
import { dialog } from "@/lib/modals.js"

const {
  MODAL_POPUP_OPEN,
  MODAL_POPUP_CLOSE,
  SHOPIFY_BLOCK_SELECT,
  SHOPIFY_BLOCK_DESELECT,
  SHOPIFY_SECTION_LOAD,
} = EVENTS

class PopupsSection extends HTMLElement {
  constructor() {
    super()

    this.classes = { visible: "visible" }

    this.selectors = { tab: (id) => `[js-popup-tab][data-id="${id}"]` }
  }

  connectedCallback() {
    this.eventController = new AbortController()

    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_SELECT,
      (e) => {
        this.#handleBlockSelected(e)
      },
      {
        signal: this.eventController.signal,
      },
    )
    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_DESELECT,
      (e) => {
        this.#handleBlockDeselected(e)
      },
      {
        signal: this.eventController.signal,
      },
    )
    this.parentElement.addEventListener(
      SHOPIFY_SECTION_LOAD,
      () => {
        this.#handleSectionLoad()
      },
      {
        signal: this.eventController.signal,
      },
    )
  }

  disconnectedCallback() {
    this.eventController.abort()
  }

  #handleBlockSelected(e) {
    const blockId = e.detail.blockId
    const selectedTab = e.target.querySelector(this.selectors.tab(blockId))

    window.dispatchEvent(new CustomEvent(MODAL_POPUP_OPEN(blockId)))
    selectedTab?.classList.add(this.classes.visible)
  }

  #handleBlockDeselected(e) {
    const blockId = e.detail.blockId
    window.dispatchEvent(new CustomEvent(MODAL_POPUP_CLOSE(blockId)))
  }

  #handleSectionLoad() {
    // we need to refresh the modal registry when a block as added/removed
    // TODO: make this a feature that's native to modal.js?

    for (const entry in window.flu.dialogs) {
      window.flu.dialogs[entry][1].destroy({ dom: false })
    }

    window.flu.dialogs = {}

    document
      .querySelectorAll("dialog[data-fluco-dialog]")
      .forEach((el) => dialog(el))
  }
}

if (!customElements.get("popups-section")) {
  customElements.define("popups-section", PopupsSection)
}
